import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'draft-toolbar',
  templateUrl: 'draft-toolbar.component.html',
  styleUrls: ['draft-toolbar.component.scss']
})

export class DraftToolbarComponent {
  @Output() onDiscardDraft: EventEmitter<any> = new EventEmitter();
  @Output() onContinueDraft: EventEmitter<any> = new EventEmitter();

  discardDraft() {
    if (confirm('Are you sure you want to start over? This will permanently delete your unsubmitted application. If you do not want to start over, select "Cancel". Or, select "OK" to start over.'))
      this.onDiscardDraft.emit();
  }

  continueDraft() {
    this.onContinueDraft.emit();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/draft-toolbar/draft-toolbar.component.ts